import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import Job from '@/model/entity/job/job';
import JobDataTableReport from '@/model/service/job/report/job-data-table-report';
import JobService from '@/model/service/job/job-service';
import Techspec from '@/model/entity/job/techspec';

@Component
export default class JobIndex extends Vue
{
    @Prop({
        type: Object,
        default: null,
    })
    private techspec!: Techspec;

    @Prop({
        type: Boolean,
        default: false,
    })
    private emitActions!: boolean;

    $refs!:
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataTable: any,
    };

    protected report: JobDataTableReport|null = null;

    private created()
    {
        this.report = new JobDataTableReport(this.$serviceContainer, this.techspec);
    }

    @Watch('techspec')
    private onTechspecChanged()
    {
        if (!this.report)
        {
            return;
        }

        this.report.setTechspec(this.techspec);
        this.$refs.dataTable.reload();
    }

    /**
     * Reloads the content
     */

    public reload()
    {
        this.$refs.dataTable.reload();
    }

    /**
     * Returns the type title for the value
     *
     * @param value
     * @returns
     */

    private getTypeTitle(value: string): string
    {
        return JobService.getTypeTitle(value);
    }

    /**
     * Handles edit clicks
     *
     * @param job
     * @returns
     */

    private onEditJob(job: Job)
    {
        if (!this.emitActions)
        {
            return;
        }

        this.$emit('edit', job);
    }

    /**
     * Handles duplication request
     */

    private onDuplicateJob(job: Job)
    {
        EventBus.instance.$emit(
            'confirm-dialog',
            this.$t('job.message.duplicate_confirmation_title'),
            this.$t('job.message.duplicate_confirmation_message'),
            () =>
            {
                this.duplicate(job);
            },
        );
    }

    /**
     * Duplicates the current job
     */

    private async duplicate(job: Job)
    {
        if (!job.id)
        {
            return;
        }

        try
        {
            // Load the full job first before duplicating
            const loaded = await this.$serviceContainer.jobService.loadJob(job.id);
            if (!loaded)
            {
                throw new Error('Job not found');
            }

            const duplicate = new Job(cloneDeep(loaded.dto));
            duplicate.id = null;
            duplicate.name += ' copy';

            const duplicated = await this.$serviceContainer.jobService.createJob(duplicate);

            this.$router.push({
                name: 'job-edit',
                params: {
                    id: `${ duplicated.id }`,
                },
            }).catch();

            EventBus.instance.$emit(
                'notification',
                this.$t('job.message.duplicated_successfully'),
                'success',
            );
        }
        catch (error: unknown)
        {
            EventBus.instance.$emit(
                'notification',
                this.$t('job.error.failed_duplicating_job'),
                'error',
            );
        }
    }
}